import { configureStore } from "@reduxjs/toolkit";

import main from "./mainSlice";

export const store = configureStore({
  reducer: {
    main,
  },
  middleware: [],
});

export type RootState = ReturnType<typeof store.getState>;

export default store;
